/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Label } from "components/Form";
import { Row, Col } from "components/Grid";
import CheckBox from "components/Form/CheckBox";
import { FitinsurAPI, MessageCenter } from "utils";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import RenderButtons from "components/RenderButtons";
import {
  Heading,
  ButtonContent,
  Title,
  ButtonContainer,
  Button,
  Dialog,
} from "./styles";
import MessageExchangeEmail from "../index";
import _ from "lodash";

export default function RecipientSelection({show, idOperation, idPersonInsurer, screenState, changeRicipientState, changeState, insurersListResponse}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const [insurersChat, setInsurersChat] = useState([]);
  const [showRecipientList, setShowRecipientList] = useState(show);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const [showRecipientSelection, setShowRecipientSelection] = useState(false);

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSelect(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== contact.email);
      setSelectedItems(filteredItems);
    } else {
      let list = [...selectedItems];
      list.push(contact);
      setSelectedItems([...list]);
    };
  };

  function listContactsChat(idContactDepartment) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestListContactsByType(idOperation, 'insurer-nbi', idContactDepartment, idPersonInsurer)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          loading.stop();
          history.goBack();
          return;
        }
        setInsurersChat(data.ret_value);
        loading.stop();
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${listContactsChat.name}\n` + error);
        console.error('fitPostListContact - Error:', error);
        loading.stop();
      });
  };

  function confirmContacts() {
    let body = {
      idOperation: idOperation,
      insurers: []
    }      

    const listResponseInsurers = insurersListResponse.filter((insurerItem) => insurerItem.insurer.idPersonInsurer != idPersonInsurer).map((insurerItem) => (
      {
        idPersonInsurer: insurerItem.insurer.idPersonInsurer,
        contacts: [...insurerItem.insurer.contacts]
      }
    ))
    const filteredInsurers = _.uniqBy(listResponseInsurers, 'idPersonInsurer');

    filteredInsurers.forEach(x => {
      body.insurers.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })
    
    const handleInsurersFiltered = []; 
    let array = [];
    filteredInsurers.forEach((insurer) => {
        insurer.contacts.forEach((contact) => {
          if (contact) {
            array.push({
              idPersonInsurer: insurer.idPersonInsurer,
              idContact: contact.idContact,
              email: contact.email,
            });
          }
        });
      });
      
      handleInsurersFiltered.push(...array);
      selectedItems.push(...handleInsurersFiltered); 
      
    insurersChat.forEach(x => {
      body.insurers.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })
    selectedItems.forEach(x => {
      let i = body.insurers.findIndex(e => e.idPersonInsurer == x.idPersonInsurer);
      if (i != -1) {
        body.insurers[i].contacts.push({ idContact: x.idContact, email: x.email });
      }
    })

    console.log('Inside the body: ', body.insurers);

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestConfirmContacts(idOperation, body.insurers.filter(x => x.contacts.length > 0)).then(response => response.json())
      .then(data => {
        if (data.ret_code === 200) {
          changeRicipientState(!show); 
          changeState(!screenState);
        } else {
          mc.error(data.ret_msg_details);
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${confirmContacts.name}\n` + error);
        console.error('fitPostConfirmContact - Error:', error);
      });
  };

  const listItems = insurersChat.length ? (
    insurersChat.map((insurer) => (
      <>
        <Row
          style={{
            flexDirection: "row",
            display: "flex",
            margin: "10px 0px 5px 10px",
          }}
        >
          <Title>{insurer.insurerFirstName}</Title>
        </Row>
        {insurer.contacts.length ? (
          insurer.contacts.map((contact) => (
            <Row
              style={{
                flexDirection: "row",
                display: "flex",
                marginLeft: "5px",
                marginRight: "0px",
              }}
            >
              <Col style={{ flexDirection: "row", display: "flex" }}>
                <label>
                  <CheckBox
                    onChange={() => {
                      handleSelect(contact, insurer);
                    }}
                    checked={
                      selectedItems.find((item) => item.email === contact.email)
                        ? true
                        : false
                    }
                  />
                </label>
                <Label> {contact.legalEntity}</Label>
              </Col>

              <Col
                md={3}
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alingItems: "start",
                }}
              >
                <Label>{contact.nameContact}</Label>
              </Col>
              <Col
                md={3}
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alingItems: "start",
                }}
              >
                <Label>{contact.personContactDepartment}</Label>
              </Col>
              <Col
                md={3}
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alingItems: "start",
                }}
              >
                <Label>{contact.email}</Label>
              </Col>
            </Row>
          ))
        ) : (
          <Row
            style={{
              flexDirection: "row",
              display: "flex",
              margin: "10px 0px 5px 10px",
            }}
          >
            <Label>No results found.</Label>
          </Row>
        )}
      </>
    ))
  ) : (
    <Row
      style={{
        flexDirection: "row",
        display: "flex",
        margin: "10px 0px 5px 10px",
      }}
    >
      <Title>No results found.</Title>
    </Row>
  );

  useEffect(() => {
    setShowRecipientList(show);
  }, [show]);

  useEffect(() => {
    if (insurersChat.length > 0) {
      let list = [];
      insurersChat.forEach((insurer) => {
        insurer.contacts.forEach((contact) => {
          if (contact.existContact) {
            handleSelect(contact, insurer);
            list.push({
              idPersonInsurer: insurer.idPersonInsurer,
              idContact: contact.idContact,
              email: contact.email,
            });
          }
        });
      });
      setSelectedItems([...list]);
    }
  }, [insurersChat]);

  useEffect(() => {
    loading.start();
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      loading.stop();
      goToLoginPage();
      return;
    } else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    }
    listContactsChat();
  }, []);

  return (
    <>
      <Dialog canShow={showRecipientList}>
        <Heading>MANAGE RECIPIENT UNDERWRITERS</Heading>
          <Title>TO</Title>
          {listItems}
          <ButtonContent>
              <Button
                secundary
                type="submit"
                name="Lost"
                id="btnLost"
                onClick={() => {changeRicipientState(!show); changeState(!screenState)}}
              >
                BACK
              </Button>
              <Button
                primary
                onClick={() => confirmContacts()}
              >
                SAVE
              </Button>
          </ButtonContent>
      </Dialog>
    </>
  );
}
